import React from 'react';
import classNames from 'classnames';

import SVGs from 'tools/utilities/svg-content';

const Icons = {
  ...SVGs,
};

type SvgTypes = keyof typeof SVGs;

export type IconTypes = SvgTypes;

interface IProps {
  name: IconTypes;
  className?: string;
}

export const Icon = ({ name, className }: IProps) => {
  const icon = Icons[name];

  if (!icon) {
    // eslint-disable-next-line
    console.warn(`No icon found for ${name}`);
    return null;
  }

  const iconClassNames = classNames(
    'Icon',
    className,
    { SVG: name in SVGs },
  );

  return (
    <span className={iconClassNames} data-icon={name}>
      {icon}
    </span>
  );
};
